<template>
  <main class="content">
      <div class="row u-wa">
          <h1>
              Cities
          </h1>
      </div>
      <div class="topBar u-wa u-fright">
          <div class="topBar--item_right">
              <router-link to="/cities/add" class="btn btn_blue">
                Add new city
              </router-link>
          </div>
      </div>
      <div class="table">
          <div class="table--row table--row_header">
            
              <div v-bind:class="getSortClasses('name')" style="max-width:320px" @click="sort('name')">
                  <div class="table--col-title">
                      City
                      <div class="table--col-arrows">
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                      </div>
                  </div>
              </div>
              <div v-bind:class= "getSortClasses('timezone')" style="max-width:328px" @click="sort('timezone')">
                  <div class="table--col-title">
                      Timezone
                      <div class="table--col-arrows">
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                      </div>
                  </div>
              </div>
              <div class="table--col" style="max-width:496px">
              </div>
          </div>
          <div class="table--row" v-for="city in cities">
              <div class="table--col" style="max-width:320px">
                  <strong>
                      {{city.name}}
                  </strong>
              </div>
              <div class="table--col" style="max-width:328px">
                  <strong>
                      {{city.timezone}}
                  </strong>
              </div>
              
              <div class="table--col" style="max-width:96px">
                  <router-link :to="{ name: 'EditCities', params: { id: city.id }}" class="btn btn btn_blueLight">
                    Edit
                  </router-link>
                  
              </div>
          </div>
          
      </div>
      <a class="btn btn_green u-fleft" @click="fetchResource()" v-if="nextPage">
          Load more
      </a>
      <loading :visible.sync="loadingVisible"></loading>
  </main>
</template>
<script>
import * as ListResource from '../../mixins/listResource.mixin';
import Loading from '../Loading.vue'

export default {
  name: 'Cities',
  components: {Loading},
  mixins: [ListResource],
  data () {
    return {
      model: 'cities',
      resource: 'cities',
      cities: [],
      sortOrder: 'asc',
      sortAttribute: 'name'
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Cities.vue?2a839f50